import css from './GoodInfo.module.scss'
import React from 'react'

import { IEventDetails } from 'meta/backendControlled/structure'
import { ITicket } from 'meta/pages/tickets'

interface IProps {
  tickets: ITicket[]
  event: IEventDetails
}

type ItemWithQuantity = { title: string; description: string; id: number; quantity: number }

const GoodInfo: React.FC<IProps> = (props) => {
  const { tickets, event } = props

  const goods = tickets
    .map((ticket) => ({
      title: ticket.title,
      description: ticket.details,
      id: ticket.id,
    }))
    .reduce<Record<number, ItemWithQuantity>>((acc, item) => {
      if (acc[item.id]) {
        acc[item.id].quantity += 1
      } else {
        acc[item.id] = { ...item, quantity: 1 }
      }
      return acc
    }, {})

  return (
    <div className={css.goodInfoContainer}>
      {Object.values(goods).map((elem, key) => (
        <div key={String(key)} className={css.infoBox}>
          <div className={css.left}>
            <div className={css.icon}>
              <img src={event.policyResponse?.icon} />
            </div>
            <div className={css.text}>
              <div className={css.title}>{elem.title}</div>
              <div className={css.description}>{elem.description}</div>
            </div>
          </div>
          <div className={css.right}>
            {elem.quantity > 1 && <div className={css.quantity}>{`x${String(elem.quantity)}`}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}

export default GoodInfo
